const RELOAD_KEY = "__chunk_reload_attempted__";
const RELOAD_TS_KEY = "__chunk_reload_ts__";
const RELOAD_COOLDOWN_MS = 30_000;

export function isChunkLoadError(err) {
  if (!err) return false;
  const name = err.name || "";
  const msg = (err.message || "").toLowerCase();
  return (
    name === "ChunkLoadError" ||
    msg.includes("loading chunk") ||
    msg.includes("loading css chunk") ||
    msg.includes("failed to fetch dynamically imported module") ||
    msg.includes("import() failed") ||
    msg.includes("script error for") ||
    /\bunexpected token\b.*<.*\bin json\b/i.test(msg)
  );
}

function withinCooldown() {
  const ts = Number(sessionStorage.getItem(RELOAD_TS_KEY) || 0);
  return ts && Date.now() - ts < RELOAD_COOLDOWN_MS;
}

export function attemptRecoveryReload() {
  if (sessionStorage.getItem(RELOAD_KEY) || withinCooldown()) return false;
  sessionStorage.setItem(RELOAD_KEY, "1");
  sessionStorage.setItem(RELOAD_TS_KEY, String(Date.now()));
  window.location.reload();
  return true;
}

export function clearRecoveryFlag() {
  sessionStorage.removeItem(RELOAD_KEY);
}

export function installGlobalChunkErrorHandlers() {
  if (typeof window === "undefined") return;
  if (window.__chunkRecoveryInstalled__) return;
  window.__chunkRecoveryInstalled__ = true;

  const handle = (err) => {
    if (isChunkLoadError(err)) attemptRecoveryReload();
  };

  window.addEventListener("error", (event) => {
    handle(event.error || event);
  });

  window.addEventListener("unhandledrejection", (event) => {
    handle(event.reason);
  });

  window.addEventListener("chunk-load-permanent-failure", () => {
    window.dispatchEvent(new CustomEvent("app-needs-update"));
  });

  window.addEventListener("load", () => {
    setTimeout(clearRecoveryFlag, 10_000);
  });
}
